module.exports = __webpack_public_path__ + "static/img/9.e3fa2d15.jpg";